export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg text-background-50 text-sm font-bold">桃</span>
              <span className="text-lg font-bold font-heading text-background-50">桃子视频</span>
            </div>
            <p className="text-xs leading-relaxed text-background-400">
              桃子视频是数字系列视频聚合平台，整合91视频、97视频、51视频、92视频、98视频等热门站点资源，提供高清电影、电视剧、动漫综艺等全品类在线观影服务。无需注册，免费观看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '平台特色', href: '#features' },
                { label: '热门资源', href: '#media' },
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
                { label: '热门榜单', href: '#ranking' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门频道</h4>
            <div className="space-y-2">
              {['91视频专区', '97视频专区', '51视频专区', '92视频频道', '98视频频道', '小蓝视频精选'].map((item) => (
                <a
                  key={item}
                  href="#media"
                  className="block text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              内容合作与友情链接区域，更多优质站点即将加入，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 桃子视频 · 数字系列视频聚合平台 · 本站内容来源于网络公开资源
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">免责声明</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">联系我们</span>
          </div>
        </div>
      </div>
    </footer>
  );
}